import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  typography: {
    fontFamily: 'MyriadPro-Regular',
    h1: {
      fontFamily: 'MyriadPro-Bold', // Use Bold for headings
    },
    h2: {
      fontFamily: 'MyriadPro-Bold',
    },
    button: {
      fontFamily: 'MyriadPro-Bold', // Buttons in Bold
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: 'MyriadPro-Regular', // Force global font
        },
      },
    },
  },
});